import React from "react"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, Row } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import * as Yup from 'yup'
import { useResponse } from "../../../../hooks/useResponse"
import { payInvoice } from "../../../../api/invoices"
import ResultHandler from "../../../../components/ResultHandler"
import { formatCurrency } from "../../../../utils/formatCurrency"

const InvoicePayModal = ({show, handleClose, handleRefetch, invoice}) => {
  const { t } = useTranslation()

  const {loading, error, setData} = useResponse(payInvoice, () => {
    handleClose()
    handleRefetch()
  })

   const validation = useFormik({
    initialValues: {
        paid_amount: ""
    },
    validationSchema: Yup.object({
        paid_amount: Yup.number().required("Amount Can't Be Empty")
    }),
    onSubmit: (data) => {
        setData({type: "edit", id: invoice.id, data})
    }
   })

  return (
    <Modal isOpen={show} toggle={handleClose} centered={true}>
      <ModalBody className="py-5 px-5">
      <Form onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                }}>
        <Row>
          <Col lg={12}>
            <div className="text-center mb-3">
              <h2>How much will be paid now ?</h2>
              <span style={{fontSize: "15px"}}>Paid Amount : {formatCurrency(invoice.paid_amount)}</span>
            </div>
          </Col>
      
            <Col md={12}>
                
                <FormGroup>
                    <Label>Amount</Label>
                    <Input name="paid_amount" value={validation.values.paid_amount} onChange={validation.handleChange} invalid={validation.errors.paid_amount} type="number" />
                    {validation.touched.paid_amount && validation.errors.paid_amount && <FormFeedback>{validation.errors.paid_amount}</FormFeedback>}
                </FormGroup>
                
                <ResultHandler error={error} />
            </Col>
          <Col>
            <div className="text-center mt-3">
              {!loading && <Button
              size="lg"
              color="primary"
                className=" ms-2"
                onClick={ validation.handleSubmit}
              >
                Confirm
              </Button>}
              {loading && <Button
                size="lg"
                color="primary"
                className=" ms-2"
              >
                Wait
              </Button>}
              <Button
              size="lg"
                className=" ms-2"
                onClick={handleClose}
              >
                {t("btns.Cancel")}
              </Button>
            </div>
          </Col>
        </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default InvoicePayModal
